

import React from 'react'
import Newnavbar from './Newnavbar'
import Newfooter from './Newfooter'
import sidephone from '../Images/sidephone.png'



const PrivacyPolicy = () => {



  return (
    <div>
            <Newnavbar />

                

                  <div>
                

    <div className="bg-[#FFFDF5] min-h-screen px-4 md:px-12 py-8 text-[#333] font-sans">
      <div className="max-w-4xl mx-auto">
        {/* <section className=" flex flex-col text-center !mx-auto w-full !bg-yellow-600 !justify-center trust_below_des leading-relaxed md:space-y-[60px] space-y-[30px] md:mt-[20px] mt-[0px] px-[20px]"> */}
                      <div className='trust_below_des flex justify-center items-center'>
                        <p className="md:!text-[48px] md:py-[48px] py-[20px]  !text-[24px] !font-bold !text-gray-900 ">
                          PayBi Privacy Policy
                        </p>
                        </div>
                  {/* </section>  */}
        <p className="text-sm text-[#666] mb-6">📅 Last Updated: 12th June 2025</p>
        <p className="text-base leading-relaxed mb-6">
          By using PayBi, you agree to our Terms and Privacy Policy, which explains how we collect, store, use, and occasionally share your personal information according to this policy and applicable laws...
        </p>

        {/* Section 1 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">1. Who We Are</h2>
        <p className="mb-4">
          At PayBi ("we," "us," or "our"), protecting your privacy while delivering a secure, intuitive expense-management experience is our top priority. This Privacy Policy explains how and why we handle your personal data through the PayBi platform—including the app, account features, and website.
        </p>

        {/* Section 2 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">2. Why Read this Policy</h2>
        <p className="mb-2">This Policy covers:</p>
        <ul className="list-disc ml-6 mb-4 space-y-1">
          <li>The types of personal data we collect when you interact with PayBi (app, website, transactions).</li>
          <li>How we use this data to deliver services, ensure compliance, and improve your experience.</li>
          <li>With whom and why we might share your data.</li>
          <li>Your rights and how you can manage or control your information.</li>
        </ul>

        {/* Section 3 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">3. Contact Us</h2>
        <p className="mb-4">
          If you have questions about this policy or your data, you can reach out at <a className="text-blue-600 underline" href="mailto:help@paybi.com">help@paybi.com</a> or via our in-app support. We periodically review and update this policy. We'll post changes online, within the app, and notify you as needed.
        </p>

        {/* Section 4 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">4. What Data We Collect</h2>
        <ul className="list-disc ml-6 mb-4 space-y-2">
          <li><strong>Account Setup:</strong> Display name, mobile number, and avatar—needed to create an account. Government ID and video capture may be required.</li>
          <li><strong>Profile Customizations:</strong> Optional info like nickname or profile photo—visible to other PayBi users.</li>
          <li><strong>Transaction Details:</strong> We log amounts, merchant info, and compliance data when you send/receive money or pay bills.</li>
          <li><strong>Messaging & Contacts:</strong> If you allow access, we store message/contact identifiers to make money transfers easier.</li>
          <li><strong>Marketing Preferences:</strong> Only stored if you opt in. Can be turned off anytime.</li>
          <li><strong>Usage & Device Data:</strong> IP address, device type, browser/app version, cookies, etc.</li>
          <li><strong>Verification & Automated Checks:</strong> Identity validation, fraud detection via third-party providers.</li>
        </ul>

        {/* Section 5 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">5. How We Use Your Data</h2>
        <ul className="list-disc ml-6 mb-4 space-y-2">
          <li><strong>To Provide Services:</strong> Account management, transaction execution, fraud checks, support, and web/app features.</li>
          <li><strong>For Security & Fraud Prevention:</strong> Behavioral monitoring, fraud protection, compliance.</li>
          <li><strong>To Communicate:</strong> Updates on security, billing, and important issues.</li>
          <li><strong>For Marketing (With Consent):</strong> Product news, offers, updates. You can opt out.</li>
          <li><strong>To Improve Our Services:</strong> Analyze behavior, personalize experience, roll out updates.</li>
        </ul>

        {/* Section 6 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">6. When We Share Your Data</h2>
        <ul className="list-disc ml-6 mb-4 space-y-1">
          <li><strong>With Consent:</strong> When you approve specific uses.</li>
          <li><strong>With Other Users:</strong> When you send/receive money.</li>
          <li><strong>With Service Providers:</strong> For identity, processing, compliance.</li>
          <li><strong>Legal Requirements:</strong> If required by law or authorities.</li>
          <li><strong>Corporate Transactions:</strong> Mergers, acquisitions, or sales (data protected).</li>
          <li><strong>Group Companies:</strong> To support our services or authorized marketing.</li>
        </ul>

        {/* Section 7 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">7. Data Security</h2>
        <p className="mb-4">
          We protect your data using encryption, strict access controls, and secure storage. While we do our best to safeguard your information, we cannot promise absolute security over internet transmissions.
        </p>

        {/* Section 8 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">8. Data Retention</h2>
        <ul className="list-disc ml-6 mb-4 space-y-1">
          <li><strong>Financial & Transaction Records:</strong> Up to 6 years for compliance.</li>
          <li><strong>Profile & Support Data:</strong> Retained until account closure, then deleted or anonymized within 6 years.</li>
          <li><strong>User Data:</strong> Retained as needed for legal, regulatory, or dispute purposes.</li>
        </ul>

        {/* Section 9 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">9. Your Privacy Rights</h2>
        <ul className="list-disc ml-6 mb-4 space-y-1">
          <li>Access personal data we hold about you.</li>
          <li>Correct inaccuracies.</li>
          <li>Request deletion under certain conditions.</li>
          <li>Object to or restrict processing.</li>
          <li>Withdraw consent anytime.</li>
          <li>Export your data in a commonly-used format.</li>
          <li>Lodge a complaint with data protection authorities.</li>
        </ul>
        <p className="mb-4">
          Contact us at <a className="text-blue-600 underline" href="mailto:help@paybi.com">help@paybi.com</a> to exercise these rights. We may request verification.
        </p>

        {/* Section 10 */}
        <h2 className="text-xl font-semibold text-[#1F1F1F] mt-8 mb-2">10. Third-Party Links</h2>
        <p className="mb-12">
          Our platform may link to external sites or services that aren’t governed by our privacy practices. We recommend reviewing their privacy policies separately before using them.
        </p>
      </div>
    </div>

                  </div>     

            <Newfooter />
      
    </div>
  )
}

export default PrivacyPolicy


